export const getColumns = () =>
[
  {
    title: 'Cod ambalaj incarcat',
    field: 'dsSupportCode'
  },
  {
    title: 'Tip ambalaj incarcat',
    field: 'dsSupportName'
  },
  {
    title: 'Cantitate incarcata',
    field: 'supportNumber'
  },
  {
    title: 'Data actualizare',
    field: 'created'
  },
  {
    title: 'Operator rezolvare',
    field: 'lastUpdateBy'
  }
]
